import { render, staticRenderFns } from "./TemplatesControls.vue?vue&type=template&id=828f9f5a"
import script from "./TemplatesControls.vue?vue&type=script&lang=js"
export * from "./TemplatesControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports